import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect, useCallback, useMemo } from 'react';
import UserSession from "../../Utils/UserSession";
import { useConfig } from "../../ComponentDependency/useConfig";
import { EVALUATION_STATES, EVALUATION_STATES_TRACKING } from "../../Constants/evaluation";
var useValuationResults = function useValuationResults(track) {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    conditions = _useState2[0],
    setConditions = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    conditionLabels = _useState4[0],
    setConditionLabels = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedConditionText = _useState6[0],
    setSelectedConditionText = _useState6[1];
  var _useState7 = useState(-1),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedIndex = _useState8[0],
    setSelectedIdx = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    minPrice = _useState10[0],
    setMinPrice = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    maxPrice = _useState12[0],
    setMaxPrice = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    displayName = _useState14[0],
    setDisplayName = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    displaySubName = _useState16[0],
    setDisplaySubName = _useState16[1];
  var _useState17 = useState(''),
    _useState18 = _slicedToArray(_useState17, 2),
    displayMileage = _useState18[0],
    setDisplayMileage = _useState18[1];
  var _useState19 = useState(''),
    _useState20 = _slicedToArray(_useState19, 2),
    predictedPrice = _useState20[0],
    setPredictedPrice = _useState20[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    predictionList = _useState22[0],
    setPredictionList = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isError = _useState24[0],
    setError = _useState24[1];
  var _useState25 = useState(''),
    _useState26 = _slicedToArray(_useState25, 2),
    displayYear = _useState26[0],
    setDisplayYear = _useState26[1];
  var _useState27 = useState(0),
    _useState28 = _slicedToArray(_useState27, 2),
    buyableMaxPrice = _useState28[0],
    setBuyableMaxPrice = _useState28[1];
  var config = useConfig();
  var showSymbolPostCurrency = useMemo(function () {
    return config === null || config === void 0 ? void 0 : config.get('showSymbolPostCurrency');
  }, [config]);
  useEffect(function () {
    if (predictionList.length) {
      return;
    }
    var _ref = UserSession.getEvaluationPredictedPrice() || {},
      _ref$predictions = _ref.predictions,
      predictions = _ref$predictions === void 0 ? undefined : _ref$predictions,
      _ref$vehicle = _ref.vehicle,
      _ref$vehicle2 = _ref$vehicle === void 0 ? {} : _ref$vehicle,
      _ref$vehicle2$modelD = _ref$vehicle2['model-displayValue'],
      modelDisplayName = _ref$vehicle2$modelD === void 0 ? '' : _ref$vehicle2$modelD,
      _ref$vehicle2$makeDi = _ref$vehicle2['make-displayValue'],
      makeDisplayName = _ref$vehicle2$makeDi === void 0 ? '' : _ref$vehicle2$makeDi,
      _ref$vehicle2$variant = _ref$vehicle2['variant-displayValue'],
      variantDisplayName = _ref$vehicle2$variant === void 0 ? '' : _ref$vehicle2$variant,
      _ref$vehicle2$yearDi = _ref$vehicle2['year-displayValue'],
      yearDisplayName = _ref$vehicle2$yearDi === void 0 ? '' : _ref$vehicle2$yearDi,
      _ref$vehicle2$mileage = _ref$vehicle2['mileage-displayValue'],
      mileageDisplayName = _ref$vehicle2$mileage === void 0 ? '' : _ref$vehicle2$mileage,
      _ref$limit = _ref.limit,
      _ref$limit2 = _ref$limit === void 0 ? {} : _ref$limit,
      _ref$limit2$buyable = _ref$limit2.buyable,
      buyable = _ref$limit2$buyable === void 0 ? true : _ref$limit2$buyable,
      _ref$limit2$maxPrice = _ref$limit2.maxPrice,
      maxPrice = _ref$limit2$maxPrice === void 0 ? 0 : _ref$limit2$maxPrice;
    var predList = predictions && predictions.list;
    if (!buyable) {
      setBuyableMaxPrice(maxPrice);
    }
    if (predList && predList.length) {
      var _conditions = predList.map(function (_ref2) {
        var condition_code = _ref2.condition_code;
        return "".concat(condition_code[0].toUpperCase()).concat(condition_code.substring(1));
      });
      var conditionLabelsList = predList.map(function (_ref3) {
        var condition_display = _ref3.condition_display;
        return condition_display;
      });
      var initConditionIdx = Math.floor(predList.length / 2);
      var initCondition = predList[initConditionIdx];
      var _initCondition$price = initCondition.price,
        max = _initCondition$price.max,
        min = _initCondition$price.min,
        symbol = _initCondition$price.currency.symbol,
        predicted_price = _initCondition$price.predicted_price;
      setConditions(_conditions);
      setConditionLabels(conditionLabelsList);
      setSelectedConditionText(initCondition.condition_display);
      setSelectedIdx(initConditionIdx);
      setMaxPrice(showSymbolPostCurrency ? "".concat(max, " ").concat(symbol) : "".concat(symbol, " ").concat(max));
      setMinPrice(showSymbolPostCurrency ? "".concat(min, " ").concat(symbol) : "".concat(symbol, " ").concat(min));
      setPredictionList(predList);
      setPredictedPrice(showSymbolPostCurrency ? "".concat(predicted_price, " ").concat(symbol) : "".concat(symbol, " ").concat(predicted_price));
    } else {
      setError(true);
    }
    setDisplayName("".concat(makeDisplayName, " ").concat(modelDisplayName));
    setDisplaySubName("".concat(variantDisplayName, " ").concat(yearDisplayName));
    setDisplayMileage(mileageDisplayName);
    setDisplayYear(yearDisplayName);
  }, [predictionList, showSymbolPostCurrency, maxPrice]);
  var onSelectingCondition = useCallback(function (_ref4) {
    var value = _ref4.value;
    var numberValue = typeof value === 'number' ? value : parseInt(value, 10);
    var _predictionList$numbe = predictionList[numberValue],
      condition_display = _predictionList$numbe.condition_display,
      condition_code = _predictionList$numbe.condition_code,
      _predictionList$numbe2 = _predictionList$numbe.price,
      min = _predictionList$numbe2.min,
      max = _predictionList$numbe2.max,
      symbol = _predictionList$numbe2.currency.symbol;
    var stringValue = typeof value === 'number' ? value.toString() : value;
    if (track) {
      var trackingInfo = {
        chosen_option: condition_display,
        select_from: EVALUATION_STATES_TRACKING.VALUATION_COMPLETE,
        field_name: condition_code,
        suggested_price: "".concat(min, " - ").concat(max)
      };
      track(EVALUATION_STATES.VALUATION_ATTRIBUTE_SELECT, trackingInfo);
    }
    setSelectedConditionText(condition_display);
    setSelectedIdx(parseInt(stringValue, 10));
    setMinPrice("".concat(symbol, " ").concat(min));
    setMaxPrice("".concat(symbol, " ").concat(max));
  }, [predictionList, setSelectedConditionText, track]);
  var getArrowStyle = function getArrowStyle() {
    var left = '0%';
    switch (selectedIndex) {
      case 0:
        left = '15.1%';
        break;
      case 1:
        left = '48.6%';
        break;
      case 2:
        left = '81.4%';
        break;
    }
    return {
      left: left
    };
  };
  var getArrowStyleRevamp = function getArrowStyleRevamp() {
    var left = '0%';
    switch (selectedIndex) {
      case 0:
        left = '17%';
        break;
      case 1:
        left = '49%';
        break;
      case 2:
        left = '80%';
        break;
    }
    return {
      left: left
    };
  };
  var getPriceStyle = function getPriceStyle() {
    var left = '0%';
    switch (selectedIndex) {
      case 0:
        left = '6%';
        break;
      case 1:
        left = '18%';
        break;
      case 2:
        left = '30%';
        break;
    }
    return {
      left: left
    };
  };
  return {
    conditions: conditions,
    conditionLabels: conditionLabels,
    displayName: displayName,
    displaySubName: displaySubName,
    displayMileage: displayMileage,
    selectedConditionText: selectedConditionText,
    selectedIndex: selectedIndex,
    onSelectingCondition: onSelectingCondition,
    maxPrice: maxPrice,
    minPrice: minPrice,
    isError: isError,
    predictedPrice: predictedPrice,
    displayYear: displayYear,
    predictionList: predictionList,
    getArrowStyle: getArrowStyle,
    getPriceStyle: getPriceStyle,
    getArrowStyleRevamp: getArrowStyleRevamp,
    buyableMaxPrice: buyableMaxPrice
  };
};
export default useValuationResults;